/**
 * Utility functions for API calls that respect public mode
 */

interface FetchOptions extends RequestInit {
  headers?: HeadersInit;
}

/**
 * Wrapper around fetch that automatically adds public mode headers when needed
 * @param url - The URL to fetch
 * @param options - Standard fetch options
 * @param isPublicMode - Whether the user is in public mode
 * @param isAdmin - Whether the user is an admin
 * @returns Promise<Response>
 */
export async function fetchWithPublicMode(
  url: string,
  options: FetchOptions = {},
  isPublicMode: boolean,
  isAdmin: boolean
): Promise<Response> {
  const headers = new Headers(options.headers || {});
  
  // Add public mode header if admin is in public mode
  if (isPublicMode && isAdmin) {
    headers.set('X-Act-As-Public', 'true');
  }
  
  return fetch(url, {
    ...options,
    headers
  });
}

/**
 * Get the appropriate API parameters based on public mode
 * @param isPublicMode - Whether the user is in public mode
 * @param isAdmin - Whether the user is an admin
 * @returns Object with appropriate query parameters
 */
export function getPublicModeParams(isPublicMode: boolean, isAdmin: boolean): Record<string, string> {
  if (isPublicMode && isAdmin) {
    return {
      include_public: 'true',
      customer_filter: 'public_only'
    };
  }
  return {
    include_public: 'false'
  };
}
